let isThrottledPrice = false;

const cancelThrottlePrice = (delay = 2000) => {
    isThrottledPrice = true;
    setTimeout(() => {
        isThrottledPrice = false;
    }, delay);
};

var price = {
    init: () => {
        const searchBtn = document.getElementById("use-my-location-btn-price");
        const searchInput = document.getElementById("ort-input-price");
        const ulContainer = document.getElementById("price-location-list");
        if (!ulContainer || !searchInput) return

        const listItems = ulContainer.querySelectorAll('li');
        const errorSpan = document.getElementById("span-error-id");

        //Hide the list items initially
        listItems.forEach(item => {
            utils.common.hideElement(item);
        });

        // Serach Button
        if (searchBtn) {
            searchBtn.addEventListener("click", () => {
                if (isThrottledPrice) return;
                cancelThrottlePrice();
                searchInput.value = ""
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(async (position) => {
                        const { latitude, longitude } = position.coords;
                        getCityFromCoordinates(latitude, longitude);
                    }, (error) => {
                        showError("generalError");
                        console.error("Error getting location: ", error);
                    });
                } else {
                    showError("geolocationNotEnabled");
                }
            });

            searchInput.addEventListener("keydown", (event) => {
                if (event.key === "Enter") {
                    if (isThrottledPrice) return;
                    cancelThrottlePrice();
                    const value = event.target.value.toLowerCase();
                    if (value.length < 2) return showError("minCharacters");
                    findGeoCodingResultsPrice(value);
                }
            });
        }

        const isListExpanded = (expanded = false) => {
            if (expanded) {
                ulContainer.setAttribute("aria-hidden", "false");
                searchInput.setAttribute("aria-expanded", "true")
                searchBtn.setAttribute("aria-expanded", "true")
            } else {
                ulContainer.setAttribute("aria-hidden", "true");
                searchInput.setAttribute("aria-expanded", "false")
                searchBtn.setAttribute("aria-expanded", "false")
            }
        };

        //Coords
        const getCityFromCoordinates = (latitude, longitude) => {

            const geocodeUrl = `/api/GoogleMaps/geocode-reverse?latlng=${latitude},${longitude}`;

            fetch(geocodeUrl)
                .then(response => response.json())
                .then(data => {
                    if (data.status === "OK" && data.results.length > 0) {
                        // Find the city name in the results
                        const addressComponents = data.results[0].address_components;
                        const cityComponent = addressComponents.find(component => component.types.includes("locality") || component.types.includes("postal_town"));

                        if (cityComponent) {
                            const cityName = cityComponent.long_name.toLowerCase();
                            searchInput.value = cityName;
                            findGeoCodingResultsPrice(cityName);
                        } else {
                            showError("noResults");
                        }
                    } else {
                        showError("generalError");
                    }
                })
                .catch(() => {
                    showError("generalError");
                });
        }

        let originalListItems = [];

        const findGeoCodingResultsPrice = async (searchTerm) => {

            if (originalListItems.length === 0) {
                originalListItems = Array.from(document.querySelectorAll('li[data-lat][data-long]'));
            }

            await resetList();

            // URL for Google Maps Geocoding API
            const geocodeUrl = `/api/GoogleMaps/geocode-address?address=${encodeURIComponent(searchTerm)}`;

            await fetch(geocodeUrl)
                .then(response => response.json())
                .then(data => {
                    if (data.status === "OK") {
                        const results = data.results;
                        let foundItems = [];

                        // Iterate over the geocode results
                        results.forEach(result => {
                            const lat = result.geometry.location.lat;
                            const lng = result.geometry.location.lng;

                            // Iterate over the list items to calculate distances
                            originalListItems.forEach(item => {
                                const itemLat = parseFloat(item.getAttribute('data-lat'));
                                const itemLng = parseFloat(item.getAttribute('data-long'));

                                const distance = utils["google-maps"].calculateDistance(lat, lng, itemLat, itemLng);

                                const isAlreadyFound = foundItems.some(foundItem =>
                                    foundItem.item.getAttribute('data-lat') === item.getAttribute('data-lat') &&
                                    foundItem.item.getAttribute('data-long') === item.getAttribute('data-long')
                                );

                                if (!isAlreadyFound) {
                                    foundItems.push({ item, distance });
                                }
                            });
                        });

                        if (foundItems.length > 0) {
                            const normalize = str => str?.toLowerCase().trim();

                            let arrayOfItems = null;

                            // Filter on items that belong to the same city & sort on distance
                            const filteredItems = foundItems.filter((x) => normalize(x.item.dataset.city) === normalize(searchInput.value)).sort((a, b) => a.distance - b.distance);

                            if (filteredItems.length > 0) {
                                arrayOfItems = filteredItems
                            } else {
                                // Take the 10 closest
                                arrayOfItems = foundItems.sort((a, b) => a.distance - b.distance).slice(0, 10);
                            }

                            ulContainer.innerHTML = '';

                            arrayOfItems.forEach(({ item }) => {
                                utils.common.showElement(item);
                                ulContainer.appendChild(item);
                            });

                            utils.common.showElement(ulContainer);
                            isListExpanded(true);
                        } else {
                            originalListItems.forEach(item => {
                                utils.common.hideElement(item);
                            });
                            utils.common.hideElement(ulContainer);
                            isListExpanded(false);
                            showError('noResults');
                        }
                    } else {
                        originalListItems.forEach(item => {
                            utils.common.hideElement(item);
                        });
                        utils.common.hideElement(ulContainer);
                        isListExpanded(false);
                        showError('generalError');
                    }
                })
                .catch(error => console.log(error));
        };

        const resetList = () => {

            ulContainer.innerHTML = '';

            originalListItems.forEach(item => {
                utils.common.hideElement(item);
                ulContainer.appendChild(item);
            });

            utils.common.hideElement(ulContainer);

        };

        const showError = (key, duration = 5000) => {
            const message = window.umbracoTranslations[key] || window.umbracoTranslations.generalError;

            utils.common.showElement(errorSpan);
            errorSpan.innerText = message;
        
            setTimeout(() => {
                errorSpan.innerText = "";
                utils.common.hideElement(errorSpan);
            }, duration);
        };

        // Handle clicks outside the dropdown to close it
        document.addEventListener("click", (event) => {
            if (ulContainer.getAttribute("aria-hidden") === "false") {
                if (!ulContainer.contains(event.target) && !searchInput.contains(event.target) && !searchBtn.contains(event.target)) {
                    isListExpanded(false);
                    utils.common.hideElement(ulContainer);
                }
            }
        });
    }
};

document.addEventListener("DOMContentLoaded", () => { price.init(); });
